import { Toaster } from "@admin-ui/components/primitives/application/toast";
import { ModalRoot } from "@inertiaui/modal-react";
import type { ReactNode } from "react";
import { useAdminFlashNotifications } from "@/hooks/use-admin-flash-notifications";
import { PrefetchProvider } from "@/providers/prefetch-provider";
import { RouterProvider } from "@/providers/router-provider";

export default function AdminPersistentLayout({ children }: { children: ReactNode }) {
  useAdminFlashNotifications();

  return (
    <RouterProvider>
      <PrefetchProvider>
        {children}
        <Toaster />
        <ModalRoot />
      </PrefetchProvider>
    </RouterProvider>
  );
}
